import { render } from "./historyCheck.vue?vue&type=template&id=5d9863cc"
import script from "./historyCheck.vue?vue&type=script&lang=js"
export * from "./historyCheck.vue?vue&type=script&lang=js"

import "./historyCheck.vue?vue&type=style&index=0&id=5d9863cc&lang=scss&scope=true"

import exportComponent from "E:\\06film\\web\\film-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__